export default "/assets/images/unit-slide2.4bd9b9fb4e2a0f09.jpg";